import React from "react";

class CustomLineItem extends React.Component {
  constructor() {
    super();

    this.state={
    name:'',
    sku:'',
    quantity:'',
    price:'',
    properties:'',
    propertiesArray:[]       
    }



  }

//   handleFormChange = (e) =>{
//     this.setState({[e.target.id]: e.target.value});
// }

handleChange=(e)=>{

    this.setState({
        [e.target.name]:e.target.value,
    })
}

handleAddProperties=()=>{
const{properties,propertiesArray}=this.state
if (properties.trim() !== '') {
    this.setState({
      propertiesArray: [...propertiesArray, { name: properties, value: '' }],
      properties: '', // Clear the property field after adding
    });
  }
};


handleSubmit = () => {
    // Perform actions based on the collected data
    console.log('Submitted Data:', this.state);
  };


  render() {

    const{name,sku,quantity,price,properties,propertiesArray}=this.state
    // console("data items",name,sku,quantity)
    return (
      <div className="container">
        <div className="mt-4 m-5 ">
        <form>					<div className="row" >
                                   
										<div className="col-lg-12 ">
											<div className="card border border-1 shadow-sm p-3">
												<div className="row">
													<div className="col-md-2">
														<div className="img-wrapper bg-light">
															<img src="" alt="" className="img-fluid" />
														</div>
													</div>
													<div className="col-md-8">
                                                   
														<div class="mb-3 row">
															<label
																for="inputtext"
																class="col-12 col-lg-2 col-form-label"
															>
																Name
															</label>
															<div class="col-12 col-lg-6">
																<input
																	type="text"
																	class="form-control"
																	id="inputtext"
																	placeholder="5"
                                                                   
                                                                    
																/>
															</div>
														</div>
														<div class="mb-3 row">
															<label
																for="inputtext"
																class="col-12 col-lg-2 col-form-label"
															>
																SKU
															</label>
															<div class="col-12 col-lg-6">
																<input
																	type="text"
																	class="form-control"
																	id="inputtext"
																	placeholder="5"
                                                                   
                                                                    
																/>
															</div>
														</div>
														<div class="mb-3 row">
															<label
																for="inputtext"
																class="col-12 col-lg-2 col-form-label"
															>
																Quantity
															</label>
															<div class="col-12 col-lg-6">
																<input
																	type="text"
																	class="form-control"
																	id="inputtext"
																	placeholder="5"
                                                                   
                                                                   
																/>
															</div>
														</div>
													</div>
													<div className="col-md-2">
														<div className="text-center">
															<button type="button" className="btn-base btn-sm w-100" disabled>Button</button>
														</div>
													</div>
												</div>
												<div className="row mt-4">
													<div className="col-md-6">
														<div class="mb-3 row">
															<label
																for="inputtext"
																class="col-12 col-lg-2 col-form-label"
															>
																Caption
															</label>
															<div class="col-12 col-lg-6">
																<input
																	type="text"
																	class="form-control"
																	id="inputtext"
																	placeholder="5"
                                                                    
																/>
															</div>
														</div>
													</div>
													<div className="col-md-6">
														<div class="mb-3 row justify-content-end">
															<label
																for="inputtext"
																class="col-12 col-lg-3 col-form-label"
															>
																Supplier Cost
															</label>
															<div class="col-12 col-lg-3">
																<input
																	type="text"
																	class="form-control"
																	id="inputtext"
																	placeholder="5"
                                                                   
																/>
															</div>
														</div>
														<div class="mb-3 row justify-content-end">
															<label
																for="inputtext"
																class="col-12 col-lg-3 col-form-label"
															>
																Customer Price
															</label>
															<div class="col-12 col-lg-3">
																<input
																	type="text"
																	class="form-control"
																	id="inputtext"
																	placeholder="5"
                                                                   
                                                                    name="price"
																/>
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
									<div className="listItems-boxes">
										<div className="container">
											<div className="row mt-2">
												<div className="col-lg-12">
													<div className="card border border-1 shadow-sm p-3">
														<div className="row">
															<div className="col-md-2">
																<div className="img-wrapper bg-light">
																	<img src="" alt="" className="img-fluid" />
																</div>
															</div>
															<div className="col-md-7">
																<div class="mb-3 row">
																	<label
																		for="inputtext"
																		class="col-12 col-lg-2 col-form-label"
																	>
																		Property
																	</label>
																	<div class="col-12 col-lg-6">
																		<input
																			type="text"
																			class="form-control"
																			id="inputtext"
																			placeholder="5"
                                                                           
																		/>
																	</div>
																</div>
																<div class="mb-3 row">
																	<label
																		for="inputtext"
																		class="col-12 col-lg-2 col-form-label"
																	>
																		Attribute
																	</label>
																	<div class="col-12 col-lg-6">
																		<input
																			type="text"
																			class="form-control"
																			id="inputtext"
																			placeholder="5"
                                                                            
																		/>
																	</div>
																</div>
																<div class="mb-3 row">
																	<label
																		for="inputtext"
																		class="col-12 col-lg-2 col-form-label"
																	>
																		Caption
																	</label>
																	<div class="col-12 col-lg-6">
																		<input
																			type="text"
																			class="form-control"
																			id="inputtext"
																			placeholder="5"
                                                                            
																		/>
																	</div>
																</div>
															</div>
															<div className="col-md-3">
																<div className="row">
																	<div className="col-md-12">
																		<div className="text-center pb-4">
																			<button type="button" className="btn-base btn-sm w-100" disabled>Button</button>
																		</div>
																	</div>
																	<div className="col-md-12">
																		<div class="mb-3 row ">
																			<label
																				for="inputtext"
																				class="col-12 col-lg-4 col-form-label"
																			>
																				Supplier Cost
																			</label>
																			<div class="col-12 col-lg-8">
																				<input
																					type="text"
																					class="form-control"
																					id="inputtext"
																					placeholder="5"
                                                                                    
																				/>
																			</div>
																		</div>
																		<div class="mb-3 row ">
																			<label
																				for="inputtext"
																				class="col-12 col-lg-4 col-form-label"
																			>
																				Customer Price
																			</label>
																			<div class="col-12 col-lg-8">
																				<input
																					type="text"
																					class="form-control"
																					id="inputtext"
																					placeholder="5"
                                                                                    
																				/>
																			</div>
																		</div>
																	</div>
																</div>
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
									<div className="mt-4">
										<div class="d-flex gap-4 justify-content-center">
											<button class="btn-base btn-sm" type="button">Add Property Bottom</button>
											<button class="btn-base btn-sm" type="button">Add Property Top</button>
										</div>
									</div>
									<div className="text-end mt-3 mb-5">
									{/* <button  type="submit" className="btn-sm btn-outline-additem"  >Add List Item</button> */}
								</div>	
                                </form>
								</div>
      </div>
    );
  }
}

export default CustomLineItem;
